import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { FriendsSurveyComponent } from './friendsSurvey.component';
import { Shell } from '@app/shell/shell.service';
import { getRoutePath, PlRoute } from '@app/utils/routes';
import { RouteData } from '@app/app-routing.module';

const routes: Routes = [
  Shell.childRoutes(
    [
      {
        path: `${getRoutePath(PlRoute.friendsSurvey, false)}/:pageNumber`,
        component: FriendsSurveyComponent,
        data: { hideMenu: true, hideProfileSection: true, disableLinkOnPlLogo: true } as RouteData,
      },
    ],
    false,
  ),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class FriendsSurveyRoutingModule {}
